<template>
  <div id="waiting">
    <div class=" bg-container">
      <div class="bg"></div>
      <div class="bg bg2"></div>
      <div class="bg bg3"></div>
    </div>

    <div class="content" id="mainUI">
      <img :src="baseUrl + 'img/treasure-chest.png'" alt="Chest" class="chest-img">
      <div class="status-text" id="statusLabel" v-html="statusLabel"></div>
    </div>
  </div>
</template>

<script>
import { Api } from '@/services';
import { useHead } from '@vueuse/head'

export default {
  name: 'WaitingPage',
  setup() {
    useHead({
      link: [
        { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
        { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Bangers&display=swap'
        },
        {
          rel: 'stylesheet',
          href: `${process.env.BASE_URL}css/waiting.css`
        }
      ]
    })
  },
  data() {
    return {
      wapToken: "",
      baseUrl: process.env.BASE_URL,
      attempt: 1,
      statusLabel: "KUPON JAJAN kamu<br>sedang disiapkan ...",
      delay: 2000,
      retryCount: 7,
      redirectURL: "https://idl.mobi/k/kj/1/",
      redirectURL2: "https://sinyalhati.com/player?hashid=",
      code: '',
      urlFallback: "https://kmi.mobi/l/kt?utm_source=internal&utm_medium=fallback_redirect&utm_campaign=kjw_acquisition&utm_content=missing_mo"
    };
  },
  mounted() {
    this.code = this.$route.params.waptoken
    if (this.code == "") {
      window.location.href = this.urlFallback;
    }

    this.wapToken = (this.$route.params.waptoken || "")
    setTimeout(() => {
      this.checkPayment(this.attempt, this.code)
    }, 2000);
  },
  methods: {
    showError() {
      window.location.href = this.urlFallback;
    },
    showSuccess(url) {
      //console.log(url)
      window.location.href = url;
    },
    checkPayment(attempt, code) {
      var self = this;
      this.statusLabel = `Sebentar...`;
      Api.checkPayment(code)
        .then((data) => {
          if (data.data.success == 1) {
            var srvFlag = data.data.srvFlag;
            this.writeLog(code, data.data.subsId, true, srvFlag)
          } else {
            if (attempt < this.retryCount) {
              setTimeout(() => self.checkPayment(attempt + 1, code),
                self.delay);
            } else {
              this.writeLog(code, self.urlFallback, false, -1)
            }
          }
        })
        .catch((err) => console.log(err));
    },
    writeLog(wapToken, param, isSuccess, srvFlag) {
      var self = this;
      var redirectURL = param
      if (isSuccess) {
        if (srvFlag == 0) {
          redirectURL = self.redirectURL + param;
        } else {
          redirectURL = self.redirectURL2 + param;
        }
      }
      Api.writeWaitingLog(wapToken, redirectURL)
        .then(() => {
          if (isSuccess) {
            self.showSuccess(redirectURL)
          } else {
            self.showError()
          }
        })
    }
  }
}
</script>
